import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const OpenCloseAnimation = (seconds: number = 0.2): AnimationTriggerMetadata => {
  return trigger('openClose', [
    state('open', style({
      opacity: 1
    })),
    state('closed', style({
      opacity: 0,
      height: '0px'
    })),
    transition('open => closed', [
      animate(`${seconds}s`)
    ]),
    transition('closed => open', [
      animate(`${seconds}s`)
    ]),
  ]);
};
